import {colors} from '@eCommerce/frontend-legacy-shared-library-native';
import {View} from 'native-base';
import React from 'react';

const Divider = () => {
  const {addAlpha, paleSky} = colors;

  return (
    <View
      backgroundColor={addAlpha(paleSky, 0.2)}
      height="1px"
      width="100%"
      marginTop="24px"
      marginBottom="24px"
    />
  );
};

export default Divider;
